import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { useApi } from "../../../../hooks/useApi";
import { authType } from "../../../../pages/Login";
import { Filters } from "../../../../pages/Users/UserInfo";
import Loader from "../../../DefaultStyles/Loader";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import Search from "../../../Filters/Search";
import ChatSearchResult, {
  recentChatBtnClick,
} from "./ChatSearch/ChatSearchResult";
import RecentChat from "./ChatSearch/RecentChat";

export default function ChatSearch() {
  const recentBtnClicked = useRecoilValue(recentChatBtnClick);
  const setBtnClick = useSetRecoilState(recentChatBtnClick);
  const location = useLocation();
  const auth = useRecoilValue(authType);

  console.log("⭐", recentBtnClicked);

  const [page, setPage] = useState(0);
  const [searchValue, setSearchValue] = useState<string | undefined>(
    location?.search !== "" ? location?.search?.substring(1) : ""
  );
  const [dropDownValue, setDropDownValue] = useState<OptionType>({
    value: location?.search !== "" ? "4" : "",
    label: location?.search !== "" ? "PID@파티장@파티원" : "선택",
  });
  const [searchError, setSearchError] = useState<any>(null);
  const [chatId, setChatId] = useState("");

  console.log(chatId);

  // 파티 채팅 검색
  const { response, error, loading } = useApi({
    method: "get",
    url:
      searchValue !== "" && !searchValue?.includes("@")
        ? `chat?page=${page}&size=10` +
          (dropDownValue?.value === "1" ? `&partyid=${searchValue}` : ``) +
          (dropDownValue?.value === "2" ? `&uid=${searchValue}` : ``) +
          (dropDownValue?.value === "3" ? `&roomid=${searchValue}` : ``)
        : undefined,
  });

  const chatSearchOptionList = [
    { value: "1", label: "PID" },
    { value: "2", label: "UID" },
    { value: "3", label: "Room ID" },
    { value: "4", label: "PID@파티장@파티원" },
  ];

  useEffect(() => {
    if (error) {
      setSearchError(error);
    }
  }, [error]);

  useEffect(() => {
    if (searchError && searchError?.code && searchError?.data) {
      toast.error(`${searchError.data}`, {
        onClose: () => {
          setSearchError(null);
        },
      });
    }
  }, [searchError]);

  useEffect(() => {
    if (
      (location?.search?.includes("@") &&
        location?.search?.split("@")?.length > 1) ||
      (searchValue?.includes("@") && searchValue?.split("@")?.length > 1)
    ) {
      setBtnClick(true);
      setChatId(searchValue!);
    } else {
      setBtnClick(false);
    }
  }, [location?.search, searchValue, setBtnClick]);

  useEffect(() => {}, [recentBtnClicked]);

  return (
    <>
      <Filters>
        <DropDown
          setDropDownValue={setDropDownValue}
          optionList={chatSearchOptionList}
          dropdownValue={dropDownValue}
          isDisabled={!auth?.chat}
        />

        <Search
          setSearchValue={setSearchValue}
          placeholder="입력"
          isDisabled={dropDownValue?.value ? false : true}
          defaultValue={searchValue}
        />
      </Filters>

      {/* 채팅 검색 결과 */}
      {response?.status === 200 &&
        !searchValue?.includes("@") &&
        !location?.search?.includes("@") && (
          <ChatSearchResult
            dropDownValue={dropDownValue}
            searchValue={searchValue}
            response={response}
            page={page}
            setPage={setPage}
            setChatId={setChatId}
          />
        )}

      {/* 최근 대화 조회 */}
      {recentBtnClicked && (
        <RecentChat
          dropDownValue={dropDownValue}
          searchValue={searchValue}
          chatId={chatId}
        />
      )}

      {loading && <Loader />}
    </>
  );
}
